<i18n>
{
  "en": {
    "ManageStoreButtonText": "My Store"
  },
  "th": {
    "ManageStoreButtonText": "ร้านค้าของฉัน"
  }
}
</i18n>
<template>
  <v-btn
    text
    class="blue--text "
    v-if="user && currentPage !== 'c-shop' "
    @click="navigateTo('c-shop')"
  >
    {{ $t('ManageStoreButtonText') }}
  </v-btn>
</template>

<script>
import helpers from '../mixins/helpers'
export default {
  name: 'PaowManageStoreButton',
  mixins: [helpers],
  props: {
    user: {
      type: Boolean,
      default: null
    }
  }
}
</script>

<style scoped>
</style>
